































import Vue from 'vue'
import { SearchFacets } from '@/search/types'
import cloneDeep from 'lodash/cloneDeep'

enum COLORS {
  WHITE = 'white',
  BLACK = 'black',
  GRAY = 'gray',
  BROWN = 'brown',
  BEIGE = 'beige',
  BLUE = 'blue',
  NAVY = 'navy',
  PURPLE = 'purple',
  GREEN = 'green',
  RED = 'red',
  PINK = 'pink',
  ORANGE = 'orange',
  YELLOW = 'yellow',
  CAMO = 'camo',
  OTHER = 'other'
}

const COLOR_CODES = {
  [COLORS.WHITE]: '#FFFFFF',
  [COLORS.BLACK]: '#000000',
  [COLORS.GRAY]: '#666666',
  [COLORS.BROWN]: '#8B572A',
  [COLORS.BEIGE]: '#D3BAA5',
  [COLORS.BLUE]: '#3294DD',
  [COLORS.NAVY]: '#14336F',
  [COLORS.PURPLE]: '#875CAD',
  [COLORS.GREEN]: '#82BE40',
  [COLORS.RED]: '#DB1D4B',
  [COLORS.PINK]: '#ED90CD',
  [COLORS.ORANGE]: '#ED7042',
  [COLORS.YELLOW]: '#F8E71C',
  [COLORS.OTHER]: '#E0E0E0'
}

export default Vue.extend({
  props: {
    searchFacet: {
      type: Object as () => SearchFacets,
      required: true
    },
    value: {
      type: String,
      default: ''
    }
  },
  data(): {
    facetValueNames: string
  } {
    return {
      facetValueNames: cloneDeep(this.value)
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal: string, oldVal: string) {
        if (newVal !== oldVal) {
          this.facetValueNames = newVal
        }
      }
    },
    facetValueNames(newVal: string, oldVal: string) {
      if (newVal !== oldVal) {
        this.$emit('onColorsChange', {
          oldValue: oldVal,
          newValue: newVal
        })
      }
    }
  },
  methods: {
    getColorStyle(color: string): { [key: string]: string } {
      const ascendColor = COLORS[
        color.toUpperCase() as keyof typeof COLORS
      ] as keyof typeof COLOR_CODES
      const isBrightColor = color === COLORS.WHITE || color === COLORS.OTHER

      return {
        '--background-color':
          color === COLORS.CAMO
            ? 'linear-gradient(-45deg, #5C4D25 50%, #417505 50%)'
            : COLOR_CODES[ascendColor],
        '--border-color':
          color === COLORS.WHITE
            ? COLOR_CODES[COLORS.BLACK]
            : COLOR_CODES[COLORS.WHITE],
        '--check-icon-url': `url(${require(`common/search/icon-check-${
          isBrightColor ? COLORS.BLACK : COLORS.WHITE
        }.svg`)})`
      }
    },
    onChangeValue(value: string) {
      if (value === this.facetValueNames) {
        this.$emit('onColorsChange', {
          oldValue: value,
          newValue: ''
        })
      }
    }
  }
})
